module.exports = __webpack_public_path__ + "svg/new-lindorff-big.120ae755807f66ebc81143548c5bae57.svg";